/**
 * 人脸检测计算
 */
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { getImageInstance } from "./image-auto-crop";
/**
 *  计算人脸宽高及位置
 */
export const computeFaceInfo = (faceRawInfo, originImage, faceAreaRatio, containerRatio = 1) => __awaiter(void 0, void 0, void 0, function* () {
    // 选第一个人脸
    const faceInfo = faceRawInfo[0];
    const { bd_box } = faceInfo[0];
    const width = Math.max(bd_box.down_right_p.x - bd_box.up_left_p.x);
    const height = Math.max(bd_box.down_right_p.y - bd_box.up_left_p.y);
    const left = bd_box.up_left_p.x;
    const top = bd_box.up_left_p.y;
    return yield setFaceCenter(width, height, left, top, originImage, faceAreaRatio, containerRatio);
});
/**
 * 设置人脸到中心 使用 canvas
 * 获取人脸位置 up_left_p, down_right_p --> 计算得到 width, height, left, top,
 * 使用 canvas 进行裁切, 得到1:1图片
 */
const setFaceCenter = (faceWidth, faceHeight, faceLeft, faceTop, originImage, faceAreaRatio = .3, containerRatio = 1) => __awaiter(void 0, void 0, void 0, function* () {
    // 裁取人头
    const $image = yield getImageInstance(originImage);
    const { width, height } = $image;
    // 截取的目标宽度及左上角信息
    let targetWidth = faceWidth;
    let targetHeight = faceHeight;
    let targetTop = faceTop;
    let targetLeft = faceLeft;
    // 保证1:1，超出图片范围的情况
    const faceRatio = faceWidth / faceHeight;
    if (faceRatio > containerRatio) {
        // 宽度 > 高度，需要调整高度和宽度相等
        targetHeight = faceWidth / containerRatio;
        targetTop = faceTop - (targetHeight - faceHeight) / 2;
    }
    else if (faceRatio < containerRatio) {
        // 宽度 < 高度，需要调整宽度至高度相等
        targetWidth = faceHeight;
        targetLeft = faceLeft - (targetWidth - faceWidth) / 2;
    }
    // 设置占比, 此时已经是正方形，目前人脸占比是100%
    const scaleFaceArea = (targetWidth * targetHeight) / faceAreaRatio;
    let targetScaleHeight = Math.sqrt(scaleFaceArea / containerRatio);
    let targetScaleWidth = targetScaleHeight * containerRatio;
    // 计算距离图片顶部位置
    let targetScaleLeft = targetLeft - (targetScaleWidth - targetWidth) / 2;
    let targetScaleTop = targetTop - (targetScaleHeight - targetHeight) / 2;
    // 边缘检测-- 高度超限
    if (targetScaleTop + targetScaleHeight > height) {
        const surplusHeight = targetScaleTop + targetScaleHeight - height;
        targetScaleTop = targetScaleTop - surplusHeight;
    }
    // 边缘检测-- 宽度超限
    if (targetScaleLeft + targetScaleWidth > width) {
        const surplusWidth = targetScaleWidth + targetScaleLeft - width;
        targetScaleLeft = targetScaleLeft - surplusWidth;
    }
    const faceRect = {
        width: targetScaleWidth,
        height: targetScaleHeight,
        top: targetScaleTop,
        left: targetScaleLeft,
    };
    return faceRect;
});
